<template>
  <div @click="onClick" style="cursor: pointer">
    <img :src="$config.instagramDark" />
    <!-- <img v-else :src="$config.instagramLight" class="insta"> -->
  </div>
</template>
<script>
export default {
  props: {
    onClick: {
      type: Function,
    },
    dark: {
      type: Boolean,
    },
  },
};
</script>
<style>
.insta {
  width: 22px;
  height: 22px;
}
</style>
